import axios from "axios";
import { API_BASE_URL } from "./config";

const instance = axios.create({
  baseURL : API_BASE_URL
})

instance.interceptors.request.use((request) => {
  const token = localStorage.getItem('token');
  request.headers['Authorization'] = token;

  return request;
})

export default instance;